<ngx-app-bar
  class="w-100"
  [title]="wallet()?.title"
  [rightButton]="{
    icon: 'arrow-right',
    style: 'neutral-link',
    mode: 'icon-only',
    size: 'medium',
  }"
  (onRightButtonClick)="onBackHandler()"
/>

@if (loading()) {
  <app-spinner class="w-100" />
} @else {
  <div class="w-100 d-flex flex-wrap px-plus mt-plus">
    <div class="w-100 d-flex">
      <wealth-applet-inventory-availible
        [wallet]="wallet()"
        class="w-100 d-flex flex-wrap radius-plus surface-elevated p-plus"
      />
    </div>

    <div class="w-100 d-flex mt-big">
      <wealth-applet-wallet-actions
        class="w-100"
        [buttons]="walletActions()"
        (actionHandler)="actionHandler($event)"
      />
    </div>

    <div class="w-100 d-flex mt-big">
      <wealth-applet-inventory-profit
        class="w-100 d-flex flex-wrap radius-plus surface-elevated p-plus"
        [wallet]="wallet()"
      />
    </div>

    <div class="w-100 d-flex flex-wrap">
      @if (wallet()?.hasTransactions && wallet().bnpl.status !== 'None') {
        <div class="w-100 credit-container">
          <div
            class="credit-wrapper"
            [id]="wallet().bnpl.status + '_CREDIT'"
          ></div>
          <wealth-applet-wallet-credit
            class="w-100 d-flex mt-big"
            [walletTitle]="wallet().title"
            [walletName]="wallet().walletName"
            [creditStatusEnum]="wallet().bnpl.status"
            [creditAmount]="wallet().bnpl.amount"
            (handleBnplClicked)="handleCredit()"
          />
        </div>
      }

      <div class="w-100 d-flex mt-big">
        <wealth-applet-get-credit-guids
          class="w-100 d-flex flex-wrap radius-plus surface-elevated cursor-pointer"
          (click)="creditGuids()"
        />
      </div>

      <wealth-applet-wallet-diposit-hints
        class="w-100 d-flex flex-wrap radius-plus surface-elevated p-small mt-big mb-huge"
        [bannerUrl]="'./wealth-assets/images/diposit-hint.png'"
        [dailyPercentage]="wallet()?.profit.dailyPercentage"
        [walletTitle]="wallet().title"
      />
    </div>
  </div>
}
